<app-main-primeng-table [id]="'cmxa-feedback-table-' + feedbackTableType + '-' + smartNumber"
                        [rowData]="feedbackRecords$ | async"
                        [rows]="10"
                        [tableType]="feedbackTableType"
                        [columnResizeMode]="'expand'"
                        [scrollable]="true"
                        [scrollHeight]="'auto'"
                        [wrapCellText]="true">
</app-main-primeng-table>
